document.addEventListener('DOMContentLoaded', function() {
  var header = document.querySelector('.header-container');
  var headerHeight = header.offsetHeight;

  window.addEventListener('scroll', function() {
    if (window.innerWidth >= 799 && window.scrollY > headerHeight) {
      header.classList.add('fixed');
    } else {
      header.classList.remove('fixed');
    }
  });

  // Recheck on window resize
  window.addEventListener('resize', function() {
    if (window.innerWidth < 799) {
      header.classList.remove('fixed');
    }
  });
});
